import { activeCameraIdAtom } from "@/atoms/activeCamera";
import { activeRegionAtom } from "@/atoms/activeRegion";
import Layout from "@/components/Layout";
import FlaglerArticle from "@/components/Seo/FlaglerArticle";
import Seo from "@/components/Seo/Seo";
import { useFlaglerReadings } from "@/hooks/useFlaglerReadings";
import {
  buildFlaglerJsonLd,
  FLAGLER_PIER_ID,
  FLAGLER_REGION_ID,
  FLAGLER_SURF_CAM_ID,
  flaglerMetaDescription,
  flaglerPageFaqs,
  getFlaglerLanding,
} from "@/lib/flaglerLandings";
import { writeLastViewedRegionId } from "@/lib/floridaHome";
import { Container } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useSetRecoilState } from "recoil";

export default function FlaglerLandingPage({ path }: { path: string }) {
  const page = getFlaglerLanding(path);
  const setActiveRegion = useSetRecoilState(activeRegionAtom);
  const setSavedCameraId = useSetRecoilState(activeCameraIdAtom);
  const readings = useFlaglerReadings(Boolean(page));

  useEffect(() => {
    if (!page) return;
    writeLastViewedRegionId(FLAGLER_REGION_ID);
    setActiveRegion(FLAGLER_REGION_ID);
    setSavedCameraId(page.topic === "cam" ? FLAGLER_SURF_CAM_ID : FLAGLER_PIER_ID);
  }, [page, setActiveRegion, setSavedCameraId]);
  const description = page ? flaglerMetaDescription(page, readings) : "";
  const faqs = useMemo(
    () => (page ? flaglerPageFaqs(page, readings, null) : []),
    [page, readings],
  );
  const structuredData = useMemo(
    () => (page ? buildFlaglerJsonLd(page, readings) : undefined),
    [page, readings],
  );

  if (!page) return null;

  return (
    <>
      <Seo
        title={page.title}
        description={description}
        canonicalPath={page.path}
        structuredData={structuredData}
      />
      <Layout>
        <Container maxWidth="xl" sx={{ py: { xs: 1.5, md: 2 } }}>
          <FlaglerArticle
            page={page}
            readings={readings}
            faqs={faqs}
            showTitle
            showPlayers
          />
        </Container>
      </Layout>
    </>
  );
}
